/**
 * discountOptions.ts
 *
 * The words for a discount's Type and Applies To, and what a new discount
 * starts as. The quote editor and the Quote Discounts admin page both read
 * these, so staff see the same terms in both places.
 *
 * Labels and order are legacy's quote editor dropdowns
 * (lib/patient-details/quote-discounts-display-new.php:194-198, :212-213).
 * Legacy's own admin page words the same five scopes differently
 * (admin/admin_discounts_details.php:218-244: "Procedure Fees", "Material
 * Fees", "Operating Room Fee", "Anesthesia Fee", listed all/proc/mat/or/anes)
 * and says "Percent"; V5 uses the editor's words in both places.
 *
 * A new discount starts as Flat Amount on Total Quote: legacy's admin form
 * leaves both selects unset for a new row, so the first option of each wins
 * (admin_discounts_details.php:67-68), and its inline add passes
 * isPercent '0' and 'all' (admin_discounts_list.php:361).
 */
import type { DiscountScope } from '@/services/admin.service';

/** Type choices, keyed by legacy's quote_discounts.isPercent. */
export const DISCOUNT_TYPE_OPTIONS: readonly { isPercent: boolean; label: string }[] = [
  { isPercent: false, label: 'Flat Amount' },
  { isPercent: true, label: 'Percentage' },
];

/** Which part of the quote a discount comes off (quote_discounts.quoteElement). */
export const DISCOUNT_SCOPE_OPTIONS: readonly { value: DiscountScope; label: string }[] = [
  { value: 'all', label: 'Total Quote' },
  { value: 'proc', label: 'Procedures' },
  { value: 'or', label: 'Operating Room' },
  { value: 'anes', label: 'Anesthesia' },
  { value: 'mat', label: 'Products' },
];

export const DEFAULT_DISCOUNT_IS_PERCENT = false;
export const DEFAULT_DISCOUNT_SCOPE: DiscountScope = 'all';

export function discountTypeLabel(isPercent: boolean): string {
  return DISCOUNT_TYPE_OPTIONS.find((o) => o.isPercent === isPercent)?.label ?? '';
}
